import { fabric } from "fabric";
import store from "apps/simplified-web/src/store";

/**
 * toObject util
 * @param {*} obj
 * @param {string[]} propertiesToInclude
 * @param {{ [key: string]: any }} [properties]
 */
export const toObject = (obj, propertiesToInclude, properties) =>
  fabric.util.object.extend(
    obj.callSuper("toObject"),
    propertiesToInclude.reduce(
      (prev, property) =>
        Object.assign(prev, {
          [property]: obj.get(property),
        }),
      Object.assign({}, properties)
    )
  );

export const setDefaultClipPath = (fabricObject) => {
  setClipPath(
    fabricObject,
    new fabric.Rect({
      width: fabricObject.width,
      height: fabricObject.height,
      top: 0,
      left: 0,
      originX: "center",
      originY: "center",
    })
  );
};

export const setClipPath = (fabricObject, clipPath) => {
  fabricObject.set("clipPath", clipPath);
};

export const moveToRelativeLayerAsObject = (
  canvas,
  sourceObject,
  targetObject,
  delta
) => {
  const state = store.getState();
  const level = (state.layerstore.layers[sourceObject.id]?.order ?? 0) + delta;
  setObjectLayer(canvas, targetObject, level);
};

export const setObjectLayer = (canvas, fabricObject, level) => {
  canvas.moveTo(fabricObject, level);
};
